// extracted by mini-css-extract-plugin
module.exports = {"page":"auto-apply_page__6Yd5g"};